import { httpClient } from "../../../utils/HttpClient";
import { ApiEndpoint } from "../../../utils/ApiEndpoint";
export const fetchMessageTemplates = async ({ uid_partner, token }) => {
  const res = await httpClient(
    "GET",
    `${ApiEndpoint}rcs/message-templates?uid_partner=${uid_partner}`,
    {},
    token,
  );
  return res.data;
};
